// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// eslint-disable-next-line spire/fenced-imports
import { hideAll } from "tippy.js";

import { parseBoolean } from "@ces/XDL/Utilities";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    createSession,
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    RedirectToChangeCustomer,
    RequestSession,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

export const XngRequestSession: any = async (props: any) => {
    if (!props.tokenSuccessfullyRequested) {
        return;
    }

    const { password, rememberMe, keepMeSignedIn, returnUrl, userName } = props.parameter;

    stopWatchingForOtherTabSessionChange(); // Prevent detection of the change we're making here.
    const session = await createSession({
        password,
        rememberMe,
        keepMeSignedIn,
        returnUrl,
        userName,
        accessToken: props.apiResult?.access_token,
    });

    if (!session.successful) {
        watchForOtherTabSessionChange(); // This sign-in failed, but another tab might be successful later on.
        props.parameter.onError?.(session.errorMessage, session.statusCode);
        return;
    }

    // XNG-Changes: To make sure all tippy popups are hidden
    hideAll();

    props.dispatch({
        type: "Context/CompleteLoadSession",
        session: session.result,
    });

    props.authenticatedSession = session.result;
};

replaceInChain(chain, RequestSession, XngRequestSession);

export const XngRedirectViewOnlyToStatements: any = (props: any) => {
    const state = props.getState();
    if (!props.authenticatedSession || props.authenticatedSession.redirectToChangeCustomerPageOnSignIn) {
        return;
    }

    const session = getSession(state);
    const statementsUrl = getPageLinkByPageType(state, "StatementsPage")?.url;

    if (!parseBoolean(session?.properties?.viewOnly) || !statementsUrl) {
        return;
    }

    window.location.href = statementsUrl;

    return false;
};

addToChainAfter(chain, RedirectToChangeCustomer, XngRedirectViewOnlyToStatements);
